import React from "react";
import StoresQueryCard from "./StoresQueryCard";
import QueryResults from "./QueryResults";
import { findRequisitions } from "../api/Requisitions";
import { encodeParam } from "../util/ApiHelper";
import { StoresProps } from "../models/stores/Stores";
import { ModuleNames } from "../util/Constants";

const StoresRequisition: React.FC<StoresProps> = (props) => {
  return (
    <StoresQueryCard
      {...props}
      module={ModuleNames.Requisition}
      querySection="QW--Requisition"
      placeholder="Enter Requisition Number"
      advancedSearchLabel="Advanced Search"
      cardTitle="Requisitions"
      popoverSearch={async (val) => {
        const res = await findRequisitions(val);
        return res.status === 200 ? res.data : [];
      }}
      onBarcodeScan={async (text: any, storesTab: any, router: any, presentAlert: any) => {
        if (text) {
          const res = await findRequisitions(text);
          if (res.status === 200 && res.data.length > 0) {
            router.push(`/Stores/Requisitions/${encodeParam(text)}/${storesTab}`);
          } else {
            presentAlert({
              message: "Requisition could not be found",
              buttons: ["OK"],
            });
          }
        } else {
          presentAlert({
            message: "Requisition could not be found",
            buttons: ["OK"],
          });
        }
      }}
      ResultsComponent={QueryResults}
      cardLink={(storesTab) => `/Stores/Requisitions/replaceWithValue/${storesTab}`}
    />
  );
};

export default StoresRequisition;